import { createApiSlice } from "@common";
import {
  CURD_CONSENT_STATUS
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addConsentStatus",
    method: "post",
    url: CURD_CONSENT_STATUS,
    stateKey: "message",
  },
  {
    name: "getConsentStatus",
    method: "get",
    url: CURD_CONSENT_STATUS,
    stateKey: "data",
  },
  {
    name: "updateConsentStatus",
    method: "put",
    url: CURD_CONSENT_STATUS,
    stateKey: "message",
  },
  {
    name: "deleteConsentStatus",
    method: "delete",
    url: CURD_CONSENT_STATUS,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "consentStatus",
  apiConfig,
  customReducers,
);
const consentStatusSlice = slice;
// Export the slice's reducer
export default consentStatusSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addConsentStatus,
  getConsentStatus,
  updateConsentStatus,
  deleteConsentStatus
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actions;
